export default __webpack_public_path__ + "static/media/koupelna1.a33c02be.jpeg";